namespace $.$$ {

	type $shm_hitalama_map_widget_float_table2_cell_id = { row: number[], col: number }
	type Table2_relation_page = {
		dataset: string
		record: string
		parent_label?: string
		parent?: { dataset: string, record: string }
		source?: { dataset: string, field: string, record: string }
	}

	export class $shm_hitalama_map_widget_float_table2_link_list extends $.$shm_hitalama_map_widget_float_table2_link_list {
		check_title( link: string ) {
			return this.table2().cell_link_options( this.cell_id() )[ link ] ?? link
		}
		check_content( link: string ) {
			return this.table2().cell_link_content( this.cell_id(), link )
		}
	}

	export class $shm_hitalama_map_widget_float_table2_col_name extends $.$shm_hitalama_map_widget_float_table2_col_name {
		@ $mol_action
		event_change( next?: Event ) {
			// Preserve the input selection before changing the field schema.
			super.event_change( next )
			if( next ) this.commit( next )
		}
	}

	export class $shm_hitalama_map_widget_float_table2_relation_form extends $shm_hitalama_map_widget_float_table_form {
		table2() { return this.table() as $shm_hitalama_map_widget_float_table2 }
		page_index() { return 0 }

		custom() {
			return this.table2().relation_page_dataset( this.page_index() )!
		}

		row_index() {
			return this.table2().relation_page_row_index( this.page_index() )
		}

		title() {
			return this.table2().relation_page_title( this.page_index() )
		}

		data_value( name: string, next?: any ) {
			return this.table2().relation_page_data_value( this.page_index(), name, next )
		}

		field_link_options( name: string ) {
			return this.custom().field_link_options( name )
		}

		field_select_dictionary( name: string ) {
			return Object.fromEntries( this.custom().field_select_options( name ).map( ( value: string )=> [ value, value ] ) )
		}

		field_relation_active( name: string ) {
			const target = this.table2().relation_page_target( this.page_index() + 1 )
			return target && this.custom().field_target_dataset( name )?.link().str === new $giper_baza_link( target.dataset ).str
				? target.record : ''
		}

		@ $mol_action
		field_relation_open( name: string, link?: string ) {
			if( link === undefined ) return ''
			this.table2().relation_open_field( this.custom().field( name ), link, this.page_index() )
			return link
		}

		@ $mol_action
		field_relation_create( name: string, event?: Event ) {
			if( event === undefined ) return null
			const field = this.custom().field( name )
			const record = this.table2().relation_page_record( this.page_index() )
			if( field && record ) this.table2().relation_create( field, record, this.custom(), this.page_index() )
			else $shm_hitalama_notifications.warning( 'Сначала сохраните запись' )
			return event
		}

		field_relation_create_current( name: string ) {
			const next = this.table2().relation_page_target( this.page_index() + 1 )
			return !!next && !next.record
				&& next.source?.field === this.custom().field( name )?.link().str
		}

		@ $mol_action
		submit() {
			if( !this.submit_allowed() ) return
			const page = this.table2().relation_page_target( this.page_index() )
			for( const name of this.field_names() ) {
				if( this.field_type( name ) === 'file' ) this.field_value( name )
			}
			if( page?.source ) {
				if( !this.table2().relation_create_submit( this.custom().object_current(), this.page_index() ) ) return
				this.table2().relation_edit_close_at( this.page_index() )
				$shm_hitalama_notifications.success( 'Запись создана' )
				return
			}
			this.table2().relation_edit_close_at( this.page_index() )
			$shm_hitalama_notifications.success( 'Запись обновлена' )
		}

		@ $mol_action
		close( next?: Event ) {
			if( next === undefined ) return null
			this.table2().relation_edit_close_at( this.page_index() )
			return next
		}

	}

	export class $shm_hitalama_map_widget_float_table2 extends $.$shm_hitalama_map_widget_float_table2 {

		entity_schema_widget() {
			const dataset = this.widget().dataset()
			return this.map().Widgets_list()?.remote_list().find( widget =>
				widget.type() === 'entity' && widget.Dataset()?.remote()?.link().str === dataset.link().str
			) ?? null
		}

		entity_schema_title() {
			return this.entity_schema_widget() ? 'Показать схему сущности' : 'Создать схему сущности'
		}

		@ $mol_action
		entity_schema_open( event?: Event | null ) {
			if( !event ) return null
			const widget = this.widget()
			const dataset = widget.dataset()
			const x = widget.body_x() + widget.right_edge_x() + 40
			const y = widget.body_y()
			const title = `Схема: ${ this.title() }`
			// Resolve all suspending inputs before consuming the one-shot click.
			const operation = $shm_hitalama_map_event_claim(
				event,
				`entity_schema_open:${ widget.link_str() }`,
			)
			if( !operation ) return null
			this.Map_page().contextmenu_showed( false )
			$mol_wire_async( this ).entity_schema_open_command(
				dataset.link().str,
				x,
				y,
				title,
				operation,
			).catch( error => {
				if( !$mol_promise_like( error ) ) $mol_fail_log( error )
			} )
			return null
		}

		entity_schema_open_command(
			dataset_link: string,
			x: number,
			y: number,
			title: string,
			operation: string,
		) {
			const dataset = this.$.$giper_baza_glob.Pawn(
				new this.$.$giper_baza_link( dataset_link ),
				this.$.$shm_hitalama_map_widget_entity_table2_dataset,
			)
			const map = this.map()
			const entity = this.entity_schema_widget() ?? map.widget_add_batch( operation, ()=> {
				const presets = $shm_hitalama_map_widget_presets.for_map( map )
				const action = presets.entity
				const run = ( action as any ).orig ?? action
				return run.call( presets, [ x, y ], dataset, title ) as $shm_hitalama_map_widget
			} )
			this.Map_page().selected_links([ entity.link() ])
			this.Map_page().go_to_widget( entity.link() )
			return entity
		}

		override col_custom_code( col: number, next?: string ) {
			const index = ( this as unknown as $shm_hitalama_map_widget_float_table ).data_col_index( col )
			const field = this.table_custom().fields()[ index ]
			if( !field ) return super.col_custom_code( col, next )
			return field.custom_code( next )
		}

		dataset_by_link( link: string ) {
			if( !link ) return null
			return this.$.$giper_baza_glob.Pawn(
				new this.$.$giper_baza_link( link ),
				this.$.$shm_hitalama_map_widget_entity_table2_dataset,
			)
		}

		@ $mol_mem
		relation_maps() {
			const maps = new Map< string, $shm_hitalama_map >()
			const add = ( map: $shm_hitalama_map | null | undefined )=> {
				if( map ) maps.set( map.link().str, map )
			}
			add( this.map() )
			for( const map of ( this.$.$shm_hitalama_app.Root( 0 ).Maps() as $shm_hitalama_map_catalog ).entities() ) add( map )
			const user = this.$.$giper_baza_auth.current().pass().lord().str
			for( const team of this.$.$shm_hitalama_domain.instance().teams_for_user( user ) ) {
				for( const map of team.maps_list()?.remote_list() ?? [] ) add( map )
			}
			return [ ... maps.values() ]
		}

		@ $mol_mem
		relation_datasets() {
			return this.relation_maps().flatMap( map => ( map.Datasets()?.remote_list() ?? [] ).map( dataset => ({ map, dataset }) ) )
		}
		@ $mol_mem_key
		col_name_draft_by_field( field_link: string, next?: string ) {
			if( next !== undefined ) return next
			return this.table_custom().fields()
				.find( field => field.link().str === field_link )?.title() ?? ''
		}

		override col_name_draft( col: number, next?: string ) {
			const table = this as unknown as $shm_hitalama_map_widget_float_table
			const field = this.table_custom().fields()[ table.data_col_index( col ) ]
			if( !field ) return super.col_name_draft( col, next )
			return this.col_name_draft_by_field( field.link().str, next )
		}

		related_table_title( dataset: $shm_hitalama_map_widget_entity_table2_dataset | null ) {
			if( !dataset ) return this.widget().title()
			for( const map of this.relation_maps() ) {
				const widget = map.Widgets_list()?.remote_list().find( widget =>
					widget.type() === 'table2' && widget.Dataset()?.remote()?.link().str === dataset.link().str
				)
				if( widget ) return widget.title()
			}
			return this.widget().title()
		}
		record_first_label( dataset: $shm_hitalama_map_widget_entity_table2_dataset | null,
			record: $shm_hitalama_map_widget_entity_table2_record | null | undefined ) {
			const field = dataset?.fields()[0]
			const value = field && record?.value( field )
			return value === null || value === undefined || value === '' ? '' : String( value )
		}

		broken_record_notice() {
			const dataset = this.table_custom()
			return !dataset.record_index_active() && dataset.broken_record_links().length > 0
		}

		query_status_visible() {
			return this.broken_record_notice() ? [ this.Query_status() ] : super.query_status_visible()
		}

		query_status() {
			const dataset = this.table_custom()
			const broken = dataset.record_index_active() ? [] : dataset.broken_record_links()
			if( broken.length ) return `Повреждена запись ${ broken.slice( 0, 3 ).join( ', ' ) }${ broken.length > 3 ? ` и ещё ${ broken.length - 3 }` : '' }; она скрыта до восстановления`
			const all = dataset.record_count()
			const found = `Найдено: ${ this.filtered_indexes().length } из ${ all }`
			if( !this.checkboxes_showed() ) return found
			const checks = this.widget().table().Rows_checked()?.val() ?? {}
			const selected = Object.entries( checks ).filter( ([ key, value ]) => value && Number( key ) < all ).length
			return `${ found } · Выбрано: ${ selected }`
		}

		related_source_record() {
			return this.widget().Relation_source_record()?.remote()?.link().str || ''
		}

		related_source_field() {
			return this.widget().Relation_source_field()?.remote()?.link().str || ''
		}

		related_source_table() {
			return this.widget().Relation_source_table()?.remote()?.link().str || ''
		}

		related_source_row() {
			return this.widget().Relation_source_row()?.val() ?? -1
		}

		related_source_name() {
			return this.widget().Relation_source_name()?.val() || ''
		}

		related_source_entity() {
			const record_link = this.related_source_record()
			const field_link = this.related_source_field()
			if( !record_link || !field_link ) return null
			return this.$.$mol_error_fence( ()=> {
				const record = this.$.$giper_baza_glob.Pawn( new this.$.$giper_baza_link( record_link ), this.$.$shm_hitalama_map_widget_entity_table2_record )
				const field = this.$.$giper_baza_glob.Pawn( new this.$.$giper_baza_link( field_link ), this.$.$shm_hitalama_map_widget_entity_table2_field )
				const dataset = record.dataset()
				return dataset?.fields().some( item => item.link().str === field.link().str ) ? { record, field } : null
			}, ()=> null )
		}

		related_links(): readonly string[] {
			if( this.related_source_record() && this.related_source_field() ) {
				const source = this.related_source_entity()
				const value = source ? source.record.value( source.field ) : []
				return Array.isArray( value ) ? value.map( String ) : value ? [ String( value ) ] : []
			}
			const table_link = this.related_source_table()
			const row = this.related_source_row()
			const name = this.related_source_name()
			if( !table_link || row < 0 || !name ) return []
			const table = this.map().Tables()?.remote_list().find( table => table.link().str === table_link )
			const value = ( table?.form_custom()?.objects()[ row ] as Record<string, any> | undefined )?.[ name ]
			return Array.isArray( value ) ? value.map( String ) : value ? [ String( value ) ] : []
		}

		query_index_enabled() {
			return true
		}

		@ $mol_mem_key
		query_index_row( record: $shm_hitalama_map_widget_entity_table2_record ): $shm_hitalama_map_widget_float_table2_query_row {
			const dataset = this.table_custom()
			const fields = dataset.fields()
			const snapshot = dataset.query_snapshot_row( record )
			const values = snapshot?.values ?? record.values_for_query( fields )
			const system = snapshot?.system ?? record.system_values()
			const raw = this.widget().table_head().map( ( name, col )=> {
				if( fields[ col ] ) return values[ col ]
				return system[ String( name ) as keyof ReturnType< typeof record.system_values > ] ?? ''
			} )
			return {
				raw,
				text: raw.map( ( value, col )=> this.query_value( value, col ).toLocaleLowerCase( 'ru' ) ),
			}
		}

		/** Bounded cold-read concurrency; diagnostics may override per view. */
		query_read_batch_size() { return 32 }

		@ $mol_mem
		query_index() {
			const records = this.table_custom().records()
			const head = this.widget().table_head().map( String )
			const rows: $shm_hitalama_map_widget_float_table2_query_row[] = []
			// A cold payload may suspend on an IndexedDB Ball read or decryption.
			// Reuse completed batches instead of walking every preceding row again.
			// Bound concurrency so a query cannot start thousands of area loads at once.
			const batch = this.query_read_batch_size()
			for( let from = 0; from < records.length; from += batch ) {
				rows.push( ...this.query_index_rows([ from, Math.min( from + batch, records.length ) ]) )
			}
			return new this.$.$shm_hitalama_map_widget_float_table2_query_index(
				rows,
				head.map( name => this.filter_kind( name ) ),
			)
		}

		@ $mol_mem_key
		query_index_rows( range: readonly [ number, number ] ) {
			const records = this.table_custom().records().slice( range[0], range[1] )
			return this.$.$mol_wire_race( ...records.map( record => ()=> this.query_index_row( record ) ) )
		}

		/** A filter or sort does not require unrelated payloads or relation labels. */
		@ $mol_mem_key
		query_index_columns( columns: readonly number[] ) {
			const records = this.table_custom().records()
			const head = this.widget().table_head().map( String )
			const rows: $shm_hitalama_map_widget_float_table2_query_row[] = []
			const batch = this.query_read_batch_size()
			for( let from = 0; from < records.length; from += batch ) {
				rows.push( ...this.query_index_columns_rows([ columns, from, Math.min( from + batch, records.length ) ]) )
			}
			return new this.$.$shm_hitalama_map_widget_float_table2_query_index(
				rows,
				head.map( name => this.filter_kind( name ) ),
				columns,
			)
		}

		@ $mol_mem_key
		query_index_columns_rows( key: readonly [ readonly number[], number, number ] ) {
			const [ columns, from, until ] = key
			const records = this.table_custom().records().slice( from, until )
			return this.$.$mol_wire_race( ...records.map( record => ()=> this.query_index_columns_row([ record, columns ]) ) )
		}

		@ $mol_mem_key
		query_index_columns_row( key: readonly [ $shm_hitalama_map_widget_entity_table2_record, readonly number[] ] ): $shm_hitalama_map_widget_float_table2_query_row {
			const [ record, columns ] = key
			const fields = this.table_custom().fields()
			const head = this.widget().table_head()
			const selected = columns.filter( col => fields[ col ] )
			const projected = selected.length && selected.length === columns.length
				? this.table_custom().query_snapshot_values?.( record, selected ) : null
			const snapshot = projected ? null : this.table_custom().query_snapshot_row( record )
			const values = selected.length ? projected ? selected.map( col=> projected[col] ) : snapshot ? selected.map( col=> snapshot.values[col] ) : record.values_for_query( selected.map( col => fields[ col ] ) ) : []
			const raw: unknown[] = Array( head.length ).fill( '' )
			selected.forEach( ( col, index )=> { raw[ col ] = values[ index ] } )
			const system_columns = columns.filter( col => !fields[ col ] )
			if( system_columns.length ) {
				const system = snapshot?.system ?? record.system_values()
				for( const col of system_columns ) raw[ col ] = system[ String( head[ col ] ) as keyof typeof system ] ?? ''
			}
			return { raw, text: [] }
		}

		filtered_indexes_linear() {
			const base = this as unknown as $shm_hitalama_map_widget_float_table
			const rows = this.widget().table().table_rows()
			const head = this.widget().table_head().map( String )
			const needle = base.search_debounced().trim().toLocaleLowerCase( 'ru' )
			const indexes = rows.map( ( _, index )=> index ).filter( index => {
				const row = rows[ index ]
				return ( !needle || row.some( ( value: unknown, col: number )=>
					this.query_value( value, col ).toLocaleLowerCase( 'ru' ).includes( needle ),
				) ) && head.every( ( name, col )=> base.filter_by_name( name ).matches( row[ col ] ) )
			} )
			const sort = base.sort_state(), col = head.indexOf( sort.name )
			if( col < 0 || sort.direction === 'none' ) return indexes
			const filter = base.filter_by_name( sort.name )
			return indexes.sort( ( left_index, right_index )=> {
				const left = filter.parse( rows[ left_index ][ col ] )
				const right = filter.parse( rows[ right_index ][ col ] )
				const missing = ( value: unknown )=> value === '' || typeof value === 'number' && Number.isNaN( value )
				if( missing( left ) !== missing( right ) ) return missing( left ) ? 1 : -1
				const order = typeof left === 'number' && typeof right === 'number'
					? left - right
					: String( left ).localeCompare( String( right ), 'ru', { numeric: true } )
				return ( sort.direction === 'desc' ? -order : order ) || left_index - right_index
			} )
		}

		filtered_indexes_indexed() {
			const head = this.widget().table_head().map( String )
			const base = this as unknown as $shm_hitalama_map_widget_float_table
			const sort = base.sort_state()
			const needle = base.search_debounced().trim().toLocaleLowerCase( 'ru' )
			const filters = head.map( ( name, col )=> ({ col, filter: base.filter_by_name( name ) }) )
				.filter( item => item.filter.mode() !== 'all' )
			const needs_values = Boolean( needle ) || filters.length > 0 || sort.direction !== 'none'
			if( !needs_values ) {
				const dataset = this.table_custom()
				return dataset.record_index_active()
					? Array.from({ length: dataset.record_count() }, ( _, index )=> index )
					: dataset.records().map( ( _, index )=> index )
			}

			if( filters.some( item => item.filter.error() ) ) return []
			const sort_col = sort.direction === 'none' ? -1 : head.indexOf( sort.name )
			const columns = [ ...new Set([ ...filters.map( item => item.col ), ...( sort_col < 0 ? [] : [ sort_col ] ) ]) ].sort( ( left, right )=> left - right )
			const staged_search = Boolean( needle ) && filters.length > 0
			const query = needle && !staged_search ? this.query_index() : this.query_index_columns( columns )
			const candidates: number[][] = []
			if( needle && !staged_search ) candidates.push( query.search_candidates( needle ) )
			for( const { col, filter } of filters ) {
				candidates.push( query.filter_candidates({
					col,
					kind: filter.kind(),
					mode: filter.mode(),
					value: filter.value(),
					until: filter.until(),
				}) )
			}
			let indexes = query.intersect( candidates ).filter( index => {
				const row = query.rows[ index ]
				return ( !needle || staged_search || row.text.some( value => value.includes( needle ) ) )
					&& filters.every( item => item.filter.matches( row.raw[ item.col ] ) )
			} )
			if( staged_search ) indexes = this.query_search_indexes([ indexes, needle ])
			const col = head.indexOf( sort.name )
			if( col >= 0 && sort.direction !== 'none' ) {
				const filter = base.filter_by_name( sort.name )
				indexes.sort( ( left_index, right_index )=> {
					const left = filter.parse( query.rows[ left_index ].raw[ col ] )
					const right = filter.parse( query.rows[ right_index ].raw[ col ] )
					const missing = ( value: unknown )=> value === '' || typeof value === 'number' && Number.isNaN( value )
					if( missing( left ) !== missing( right ) ) return missing( left ) ? 1 : -1
					const order = typeof left === 'number' && typeof right === 'number'
						? left - right
						: String( left ).localeCompare( String( right ), 'ru', { numeric: true } )
					return ( sort.direction === 'desc' ? -order : order ) || left_index - right_index
				} )
			}
			return indexes
		}

		@ $mol_mem_key
		query_search_indexes( key: readonly [ readonly number[], string ] ): number[] {
			const [ indexes, needle ] = key
			const result: number[] = []
			const batch = this.query_read_batch_size()
			for( let from = 0; from < indexes.length; from += batch ) {
				result.push( ...this.query_search_batch([ indexes, needle, from, Math.min( from + batch, indexes.length ) ]) )
			}
			return result
		}

		@ $mol_mem_key
		query_search_batch( key: readonly [ readonly number[], string, number, number ] ) {
			const [ indexes, needle, from, until ] = key
			const records = this.table_custom().records()
			return this.$.$mol_wire_race( ...indexes.slice( from, until ).map( index=> ()=> {
				const row = this.query_index_row( records[index] )
				return row.text.some( value=> value.includes( needle ) ) ? index : -1
			} ) ).filter( index=> index >= 0 )
		}

		@ $mol_mem
		filtered_indexes() {
			const indexes = this.query_index_enabled()
				? this.filtered_indexes_indexed()
				: this.filtered_indexes_linear()
			if( !this.related_source_record() && !this.related_source_table() ) return indexes
			const links = new Set( this.related_links() )
			const dataset = this.table_custom()
			return indexes.filter( index => links.has( dataset.record_index_active()
				? dataset.record_link_at( index )
				: dataset.records()[ index ]?.link().str ?? ''
			) )
		}

		override rows() {
			// Grid row ids and table2 cells read records directly. Keeping a second full
			// records × fields matrix here made every append invalidate all visible cells.
			return {}
		}

		override table_rows_limit( next?: number ) {
			const limit = this.widget().table().rows_limit( next )
			if( this.fullscreen() ) return limit
			const fitted = this.table_rows_fitted()
			return limit ? Math.min( limit, fitted ) : fitted
		}

		override table_virtual() {
			return !this.fullscreen()
		}

		@ $mol_mem
		page_indexes() {
			const all = this.filtered_indexes()
			if( !this.fullscreen() ) return all
			const limit = this.table_rows_limit()
			const offset = this.page_index() * limit
			return limit ? all.slice( offset, offset + limit ) : all
		}

		table_rows_fitted() {
			const body_height = Math.max( 0, this.table_viewport_height() - this.table_header_height() )
			const row_height = Math.max( 1, this.Table().Table().row_height() )
			return Math.max( 1, Math.floor( body_height / row_height ) )
		}

		filter_kind( name: string ) {
			const field = this.table_custom().field( name )
			if( field?.type() === 'file' ) return 'file'
			if( field?.type() === 'date' || field?.type() === 'number' ) return field.type()
			return 'text'
		}

		empty_message() {
			return this.table_custom().record_count() ? 'По условиям поиска ничего не найдено' : 'Таблица пустая'
		}

		@ $mol_action
		related_attach( record: $shm_hitalama_map_widget_entity_table2_record ) {
			if( this.related_source_record() && this.related_source_field() ) {
				const source = this.related_source_entity()
				if( source ) {
					const current = source.record.value( source.field )
					source.record.value( source.field, source.field.type() === 'list_link'
						? [ ...new Set([ ...( Array.isArray( current ) ? current : [] ), record.link().str ]) ] : record.link().str )
				}
				return
			}
			const table = this.map().Tables()?.remote_list().find( item => item.link().str === this.related_source_table() )
			const row = this.related_source_row()
			const name = this.related_source_name()
			const custom = table?.form_custom()
			const objects = [ ...( custom?.objects() ?? [] ) ] as Record<string, any>[]
			if( row < 0 || !name || !objects[ row ] ) return
			const current = objects[ row ][ name ]
			objects[ row ] = { ...objects[ row ], [ name ]: custom?.field_type( name ) === 'list_link'
				? [ ...new Set([ ...( Array.isArray( current ) ? current : [] ), record.link().str ]) ] : record.link().str }
			custom?.objects( objects )
		}

		table_custom() {
			return this.widget().dataset()
		}

		table_record( index: number ) {
			const dataset = this.table_custom()
			return dataset.record_index_active() ? dataset.record_at( index ) : dataset.records()[ index ] ?? null
		}

		table_relation_options_for_name( name: string ) {
			return this.table_custom().field_link_options( name )
		}

		table_select_options_for_name( name: string ) {
			return this.table_custom().field_select_options( name )
		}

		override Cell( id: $shm_hitalama_map_widget_float_table2_cell_id ): $mol_view {
			const field = this.cell_field( id )
			if( field?.type() === 'atom_link' ) return this.Cell_atom_link( id )
			if( field?.type() === 'list_link' ) return this.Cell_list_link( id )
			if( field?.type() === 'select' ) return this.Cell_select( id )
			return super.Cell( id )
		}

		cell_select_options( id: $shm_hitalama_map_widget_float_table2_cell_id ) {
			const field = this.cell_field( id )
			return { '': 'Не выбрано', ...Object.fromEntries( ( field?.options() ?? [] ).map( ( value: string )=> [ value, value ] ) ) }
		}

		cell_select( id: $shm_hitalama_map_widget_float_table2_cell_id, next?: string ) {
			const field = this.cell_field( id )
			const record = this.cell_record( id )
			if( !field || !record ) return ''
			return String( record.value( field, next ) ?? '' )
		}

		@ $mol_mem_key
		cell_field( id: $shm_hitalama_map_widget_float_table2_cell_id ) {
			const index = ( this as unknown as $shm_hitalama_map_widget_float_table ).data_col_index( id.col )
			return this.table_custom().fields()[ index ] ?? null
		}

		@ $mol_mem_key
		cell_record( id: $shm_hitalama_map_widget_float_table2_cell_id ) {
			return this.table_record( Number( id.row[ 1 ] ) )
		}

		cell_link_options( id: $shm_hitalama_map_widget_float_table2_cell_id ) {
			const field = this.cell_field( id )
			if( !field ) return {}
			const opened = field.type() === 'list_link'
				? this.List_link_pick( id ).showed()
				: this.Atom_link_pick( id ).showed()
			if( opened ) return this.table_custom().field_link_options( field.title() )
			const links = field.type() === 'list_link'
				? this.cell_list_link( id )
				: [ this.cell_atom_link( id ) ].filter( Boolean )
			return Object.fromEntries( links.map( link => [ link, link ] ) )
		}

		cell_link_content( id: $shm_hitalama_map_widget_float_table2_cell_id, link: string ) {
			const field = this.cell_field( id )
			if( !field ) return [ this.cell_link_options( id )[ link ] ?? link ]
			return this.$.$shm_hitalama_map_widget_entity_table2_display_content(
				this.map(), this.widget().table(), this.widget(), this, field, link,
				{ [ '$' + 'cell_id' ]: id },
			)
		}

		// These channels forward storage rather than own state. A setter-side
		// memo would hide the new override source from later Undo/remote updates.
		cell_atom_link( id: $shm_hitalama_map_widget_float_table2_cell_id, next?: string ) {
			const field = this.cell_field( id )
			const record = this.cell_record( id )
			if( !field || !record ) return ''
			return String( record.value( field, next ) ?? '' )
		}

		cell_list_link( id: $shm_hitalama_map_widget_float_table2_cell_id, next?: readonly string[] ) {
			const field = this.cell_field( id )
			const record = this.cell_record( id )
			if( !field || !record ) return []
			const value = record.value( field, next )
			return Array.isArray( value ) ? value.map( String ) : []
		}

		atom_link_item_visible( id: $shm_hitalama_map_widget_float_table2_cell_id ) {
			return this.cell_atom_link( id ) ? [ this.Atom_link_item( id ) ] : []
		}

		cell_atom_link_label( id: $shm_hitalama_map_widget_float_table2_cell_id ) {
			const link = this.cell_atom_link( id )
			const field = this.cell_field( id )
			return field ? this.table_custom().field_link_label( field, link ) : link
		}

		cell_atom_link_content( id: $shm_hitalama_map_widget_float_table2_cell_id ) {
			return this.cell_link_content( id, this.cell_atom_link( id ) )
		}

		override Atom_link_pick( id: $shm_hitalama_map_widget_float_table2_cell_id ) {
			const picker = super.Atom_link_pick( id )
			picker.option_content = link => this.cell_link_content( id, link )
			return picker
		}

		cell_atom_link_current( id: $shm_hitalama_map_widget_float_table2_cell_id ) {
			return this.relation_current( id, this.cell_atom_link( id ) )
		}

		@ $mol_action
		cell_atom_link_open( id: $shm_hitalama_map_widget_float_table2_cell_id, next?: Event ) {
			if( next === undefined ) return null
			this.relation_open( id, this.cell_atom_link( id ) )
			return next
		}

		cell_list_option_ids( id: $shm_hitalama_map_widget_float_table2_cell_id ) {
			return Object.keys( this.cell_link_options( id ) )
		}

		override list_cell_id( id: $shm_hitalama_map_widget_float_table2_cell_id ) {
			return id
		}

		cell_list_picker_value( id: $shm_hitalama_map_widget_float_table2_cell_id, next?: readonly string[] ) {
			const options = this.cell_link_options( id )
			if( next === undefined ) return this.cell_list_link( id ).filter( link => link in options )
			const unavailable = this.cell_list_link( id ).filter( link => !( link in options ) )
			this.cell_list_link( id, [ ...unavailable, ...next ] )
			return next
		}

		cell_list_item_key( id: $shm_hitalama_map_widget_float_table2_cell_id, link: string ) {
			return JSON.stringify([ id.row, id.col, link ])
		}

		cell_list_item_parts( key: string ) {
			const [ row, col, link ] = JSON.parse( key ) as [ number[], number, string ]
			return { id: { row, col }, link }
		}

		@ $mol_mem_key
		cell_list_limit( id: $shm_hitalama_map_widget_float_table2_cell_id, next?: number ) {
			return next ?? 10
		}

		cell_list_visible_links( id: $shm_hitalama_map_widget_float_table2_cell_id ) {
			const field = this.cell_field( id )
			const record = this.cell_record( id )
			if( !field || !record ) return []
			const limit = this.cell_list_limit( id )
			const dataset = this.table_custom()
			if( dataset.relation_has_pages( record, field ) ) return dataset.relation_slice( record, field, 0, limit )
			return this.cell_list_link( id ).slice( 0, limit )
		}

		cell_list_total( id: $shm_hitalama_map_widget_float_table2_cell_id ) {
			const field = this.cell_field( id )
			const record = this.cell_record( id )
			if( !field || !record ) return 0
			const dataset = this.table_custom()
			return dataset.relation_has_pages( record, field )
				? dataset.relation_count( record, field )
				: this.cell_list_link( id ).length
		}

		cell_list_item_views( id: $shm_hitalama_map_widget_float_table2_cell_id ) {
			const items: $mol_view[] = this.cell_list_visible_links( id )
				.map( link => this.List_link_item( this.cell_list_item_key( id, link ) ) )
			if( this.cell_list_limit( id ) < this.cell_list_total( id ) ) items.push( this.List_link_more( id ) )
			return items
		}

		@ $mol_action
		cell_list_more( id: $shm_hitalama_map_widget_float_table2_cell_id, event?: Event ) {
			if( event === undefined ) return null
			this.cell_list_limit( id, this.cell_list_limit( id ) + 10 )
			return event
		}

		cell_list_item_label( key: string ) {
			const { id, link } = this.cell_list_item_parts( key )
			const field = this.cell_field( id )
			return field ? this.table_custom().field_link_label( field, link ) : link
		}

		cell_list_item_content( key: string ) {
			const { id, link } = this.cell_list_item_parts( key )
			return this.cell_link_content( id, link )
		}

		cell_list_item_current( key: string ) {
			const { id, link } = this.cell_list_item_parts( key )
			return this.relation_current( id, link )
		}

		@ $mol_action
		cell_list_item_open( key: string, next?: Event ) {
			if( next === undefined ) return null
			const { id, link } = this.cell_list_item_parts( key )
			this.relation_open( id, link )
			return next
		}

		cell_relation_create_current( id: $shm_hitalama_map_widget_float_table2_cell_id ) {
			if( !this.fullscreen() ) {
				const widget = this.map().Widgets_list()?.remote_list().find( widget => widget.link().str === this.relation_edit_widget() )
				return widget?.type() === 'form2' && !widget.Record2()?.remote()
					&& widget.Relation_source_field()?.remote()?.link().str === this.cell_field( id )?.link().str
					&& widget.Relation_source_record()?.remote()?.link().str === this.cell_record( id )?.link().str
			}
			const next = this.relation_page_target( 0 )
			return !!next && !next.record
				&& next.source?.field === this.cell_field( id )?.link().str
				&& next.source?.record === this.cell_record( id )?.link().str
		}

		@ $mol_mem
		relation_pages( next?: readonly Table2_relation_page[] ) {
			return next ?? []
		}

		relation_page_index( index: number ) { return index }


		relation_page_target( index: number ) {
			return this.relation_pages()[ index ] ?? null
		}

		relation_edit_target( next?: { dataset: string, record: string } | null ) {
			if( next !== undefined ) this.relation_pages( next ? [ next ] : [] )
			return this.relation_pages().at( -1 ) ?? null
		}

		@ $mol_mem
		relation_edit_widget( next?: string | null ) {
			return next === undefined ? null : next
		}

		relation_current( id: $shm_hitalama_map_widget_float_table2_cell_id, link: string ) {
			return this.relation_current_field( this.cell_field( id ), link )
		}

		relation_current_field( field: $shm_hitalama_map_widget_entity_table2_field | null, link: string ) {
			const target = this.relation_edit_target()
			if( !target || !link || new $giper_baza_link( target.record ).str !== new $giper_baza_link( link ).str ) return false
			if( field?.target_dataset()?.link().str !== new $giper_baza_link( target.dataset ).str ) return false
			const opened = this.relation_edit_widget()
			return this.fullscreen() || !!opened && !!this.map().Widgets_list()?.remote_list().some( widget => widget.link().str === opened )
		}

		table_form_relation_active( name: string ) {
			const field = this.table_custom().field( name )
			const target = this.relation_edit_target()
			return target && field?.target_dataset()?.link().str === new $giper_baza_link( target.dataset ).str
				? target.record : ''
		}

		@ $mol_action
		table_form_relation_open( name: string, link: string ) {
			this.relation_open_field( this.table_custom().field( name ), link )
		}

		@ $mol_action
		table_form_relation_create( name: string ) {
			const field = this.table_custom().field( name )
			const record = this.table_record( this.edit_row_index() )
			if( field && record ) this.relation_create( field, record )
			else $shm_hitalama_notifications.warning( 'Сначала сохраните строку таблицы' )
		}

		@ $mol_mem
		relation_create_source( next?: { field: string, record: string } | null ) {
			return next === undefined ? null : next
		}

		relation_edit_dataset() {
			const target = this.relation_edit_target()
			return target ? this.dataset_by_link( target.dataset ) : null
		}

		relation_edit_record() {
			const target = this.relation_edit_target()
			const dataset = this.relation_edit_dataset()
			if( !target?.record || !dataset ) return null
			return dataset.record_by_link( new $giper_baza_link( target.record ).str )
		}

		relation_page_dataset( index: number ) {
			const target = this.relation_page_target( index )
			return target ? this.dataset_by_link( target.dataset ) : null
		}

		relation_page_record( index: number ) {
			const target = this.relation_page_target( index )
			const dataset = this.relation_page_dataset( index )
			return target?.record && dataset ? dataset.record_by_link( new $giper_baza_link( target.record ).str ) : null
		}

		relation_page_row_index( index: number ) {
			const record = this.relation_page_record( index )
			return record ? this.relation_page_dataset( index )!.records().indexOf( record ) : -1
		}

		relation_page_title( index: number ) {
			const page = this.relation_page_target( index )
			const dataset = this.relation_page_dataset( index )
			const title = this.related_table_title( dataset )
			const parent = page?.parent
			const parent_dataset = parent ? this.dataset_by_link( parent.dataset ) : null
			const parent_record = parent_dataset?.record_by_link( parent?.record ?? '' )
			const label = parent_record ? this.record_first_label( parent_dataset ?? null, parent_record ) : page?.parent_label
			return label ? `${ title } - ${ label }` : title
		}

		relation_page_data_value( index: number, name: string, next?: any ) {
			const page = this.relation_page_target( index )
			const dataset = this.relation_page_dataset( index )
			const field = dataset?.field( name )
			const record = this.relation_page_record( index )
			if( !field || !dataset ) return ''
			if( !record && page && !page.record ) return dataset.object_current_value( name, next )
			if( !record ) return ''
			if( next === undefined ) return record.value( field )
			const value = field.type() === 'date' && next
				? new $mol_time_moment( next ).toString( 'DD.MM.YYYY' ) : next
			record.value( field, value )
			return next
		}

		@ $mol_action
		relation_edit_close_at( index: number ) {
			this.relation_pages( this.relation_pages().slice( 0, index ) )
			if( index === 0 ) this.relation_create_source( null )
		}

		@ $mol_action
		relation_edit_close() {
			const opened = this.relation_edit_widget()
			if( opened ) {
				const widget = this.map().Widgets_list()?.remote_list().find( widget => widget.link().str === opened )
				if( widget ) this.map().widget_cut( widget.link() )
			}
			this.relation_edit_widget( null )
			this.relation_edit_target( null )
			this.relation_create_source( null )
		}

		@ $mol_action
		relation_create_submit( object: Record< string, any >, index = this.relation_pages().length - 1 ) {
			const page = this.relation_page_target( index )
			const source = page?.source
			const target = this.relation_page_dataset( index )
			if( !source || !target ) return null
			const source_dataset = this.dataset_by_link( source.dataset )
			const field = source_dataset?.fields().find( item => item.link().str === source.field )
			const record = source_dataset?.record_by_link( source.record )
			if( !field || !record ) return null
			const created = target.record_add( object )
			const current = record.value( field )
			record.value( field, field.type() === 'list_link'
				? [ ...new Set([ ...( Array.isArray( current ) ? current : [] ), created.link().str ]) ]
				: created.link().str )
			target.draft_reset()
			return created
		}

		@ $mol_action
		cell_relation_create( id: $shm_hitalama_map_widget_float_table2_cell_id, event?: Event ) {
			if( event === undefined ) return null
			const command = `table2_relation_create:${ this.widget().link_str() }:${ JSON.stringify( id ) }`
			return $shm_hitalama_map_event_once( event, command, ()=> {
				const field = this.cell_field( id )
				const record = this.cell_record( id )
				if( field && record ) this.relation_create( field, record )
				return event
			} )
		}

		@ $mol_action
		relation_create( field: $shm_hitalama_map_widget_entity_table2_field, record: $shm_hitalama_map_widget_entity_table2_record,
			source = this.table_custom(), from?: number ) {
			// This action can resume independently of its caller. Re-enter the
			// creation batch here, before any suspended preparation or widget write.
			const owner = $mol_wire_sync( this ).relation_creation_owner()
			return this.map().widget_add_batch( owner, ()=> this.relation_create_apply( field, record, source, from ) )
		}

		relation_creation_owner() {
			return Object.create( null )
		}

		private relation_create_apply( field: $shm_hitalama_map_widget_entity_table2_field, record: $shm_hitalama_map_widget_entity_table2_record,
			source: $shm_hitalama_map_widget_entity_table2_dataset, from?: number ) {
			const dataset = field.target_dataset()
			if( !dataset ) {
				$shm_hitalama_notifications.warning( 'Сначала выберите связанную таблицу' )
				return
			}
			dataset.draft_relation_prepare( field, record )
			if( this.fullscreen() ) {
				if( from === undefined ) {
					this.relation_edit_close()
					;( this as unknown as $shm_hitalama_map_widget_float_table ).create_open( false )
					;( this as unknown as $shm_hitalama_map_widget_float_table ).table_editing( false )
					this.column_editor_col( -1 )
					// Keep the row form open under the related form stack.
				}
				const pages = from === undefined ? [] : this.relation_pages().slice( 0, from + 1 )
				this.relation_pages([ ...pages, { dataset: dataset.link().str, record: '',
					parent_label: this.record_first_label( source, record ),
					parent: { dataset: source.link().str, record: record.link().str },
					source: { dataset: source.link().str, field: field.link().str, record: record.link().str } } ])
				return
			}
			this.relation_edit_close()
			const widget = $mol_wire_sync( this.map() ).widget_add( 'form2',
				$mol_wire_sync( Array ).of( this.widget().body_x() + this.widget().right_edge_x(), this.widget().body_y() ) as number[], 450, 780,
				undefined, '', new ( $mol_wire_sync( $giper_baza_link ) )( dataset.link().str ) )!
			widget.title( 'Новая запись' )
			widget.Dataset( null )?.val( new $giper_baza_link( dataset.link().str ) )
			widget.Relation_source_record( null )?.val( new $giper_baza_link( record.link().str ) )
			widget.Relation_source_field( null )?.val( new $giper_baza_link( field.link().str ) )
			this.relation_edit_widget( widget.link().str )
			this.Map_page().contextmenu_showed( false )
		}

		@ $mol_action
		relation_open( id: $shm_hitalama_map_widget_float_table2_cell_id, link: string ) {
			this.relation_open_field( this.cell_field( id ), link, undefined, this.cell_record( id ) )
		}

		@ $mol_action
		relation_open_field( field: $shm_hitalama_map_widget_entity_table2_field | null, link: string, from?: number,
			parent_record?: $shm_hitalama_map_widget_entity_table2_record | null ) {
			if( !link ) return
			const dataset = field?.target_dataset()
			const current = from === undefined ? this.relation_edit_target() : this.relation_page_target( from + 1 )
			if( current && dataset && new $giper_baza_link( current.dataset ).str === dataset.link().str
				&& new $giper_baza_link( current.record ).str === new $giper_baza_link( link ).str
				&& ( this.fullscreen() || this.relation_current_field( field, link ) ) ) {
				if( from === undefined ) this.relation_edit_close()
				else this.relation_edit_close_at( from + 1 )
				return
			}
			const record = dataset?.record_by_link_direct( new $giper_baza_link( link ).str )
			if( !dataset || !record ) {
				$shm_hitalama_notifications.warning( 'Связанная запись не найдена' )
				return
			}

			if( this.fullscreen() ) {
				if( from === undefined ) {
					this.relation_edit_close()
					;( this as unknown as $shm_hitalama_map_widget_float_table ).create_open( false )
					;( this as unknown as $shm_hitalama_map_widget_float_table ).table_editing( false )
					this.column_editor_col( -1 )
					// Keep the edited row beneath linked forms.
				}
				const pages = from === undefined ? [] : this.relation_pages().slice( 0, from + 1 )
				const source_record = parent_record ?? ( from === undefined
					? this.table_record( this.edit_row_index() )
					: this.relation_page_record( from ) )
				const source_dataset = from === undefined ? this.table_custom() : this.relation_page_dataset( from )
				this.relation_pages([ ...pages, { dataset: dataset.link().str, record: record.link().str,
					parent_label: source_dataset && source_record ? this.record_first_label( source_dataset, source_record ) : '',
					parent: source_dataset && source_record ? { dataset: source_dataset.link().str, record: source_record.link().str } : undefined } ])
				return
			}
			this.relation_edit_close()

			const widget = this.map().widget_add(
				'form2',
				[ this.widget().body_x() + this.widget().right_edge_x(), this.widget().body_y() ],
				450,
				780,
				undefined,
				'',
				new $giper_baza_link( dataset.link().str ),
			)!
			widget.title( dataset.record_title( record ) )
			widget.Dataset( null )?.val( new $giper_baza_link( dataset.link().str ) )
			widget.Record2( null )?.val( new $giper_baza_link( record.link().str ) )
			this.relation_edit_target({ dataset: dataset.link().toString(), record: record.link().toString() })
			this.relation_edit_widget( widget.link().str )
			this.Map_page().contextmenu_showed( false )
		}

		override workspace_content() {
			const content = super.workspace_content()
			return this.fullscreen() && this.relation_pages().length
				? [ ... content, ...this.relation_pages().map( ( page, index )=> this.Relation_edit_panel( index ) ) ]
				: content
		}

		relation_stack_open() { return this.relation_pages().length > 0 }

		@ $mol_action
		override cell_edit( id: $shm_hitalama_map_widget_float_table2_cell_id ) {
			this.relation_edit_close()
			return super.cell_edit( id )
		}

		override col_type_options() {
			return {
				... super.col_type_options(),
				atom_link: 'Ссылка',
				list_link: 'Список ссылок',
				select: 'Выбор из списка',
			}
		}

		override col_type( col: number, next?: string ) {
			const index = ( this as unknown as $shm_hitalama_map_widget_float_table ).data_col_index( col )
			if( index >= this.table_custom().fields().length ) return 'string'
			return super.col_type( col, next )
		}

		@ $mol_action
		override col_delete_ask( col: number, event?: Event ) {
			const index = ( this as unknown as $shm_hitalama_map_widget_float_table ).data_col_index( col )
			if( index >= this.table_custom().fields().length ) {
				if( event ) $shm_hitalama_notifications.warning( 'Системное поле нельзя удалить' )
				return event ?? null
			}
			return super.col_delete_ask( col, event )
		}

		override relation_dataset_visible( col: number ) {
			const type = this.col_type( col )
			return type === 'atom_link' || type === 'list_link'
				? [ this.Relation_dataset_label( col ) ]
				: []
		}

		select_options_saved( col: number ) {
			const field = this.table_custom().fields()[ ( this as unknown as $shm_hitalama_map_widget_float_table ).data_col_index( col ) ]
			return field?.options().join( '\n' ) ?? ''
		}

		override select_options( col: number, next?: string ) {
			const field = this.table_custom().fields()[ ( this as unknown as $shm_hitalama_map_widget_float_table ).data_col_index( col ) ]
			if( !field ) return ''
			const table = this as unknown as $shm_hitalama_map_widget_float_table
			if( next !== undefined ) {
				table.select_options_draft( col, next )
				table.select_options_editing( col, true )
				field.options( [ ...new Set( next.split( '\n' ).map( value => value.trim() ).filter( Boolean ) ) ] )
			}
			return table.select_options_editing( col ) ? table.select_options_draft( col ) : this.select_options_saved( col )
		}

		override relation_dataset_options() {
			const current = this.table_custom().link().str
			return Object.fromEntries( this.relation_datasets()
				.filter( ({ dataset })=> dataset.link().str !== current )
				.map( ({ map, dataset }, index )=> {
				const widget = map.Widgets_list()?.remote_list().find( widget =>
					widget.type() === 'table2'
					&& widget.Dataset()?.remote()?.link().str === dataset.link().str
				)
				const table = widget?.title() || `Таблица ${ index + 1 }`
				return [ dataset.link().toString(), map.link().str === this.map().link().str ? table : `${ map.title() } / ${ table }` ]
			} ) )
		}

		override relation_dataset( col: number, next?: string ) {
			const index = ( this as unknown as $shm_hitalama_map_widget_float_table ).data_col_index( col )
			const field = this.table_custom().fields()[ index ]
			if( !field ) return ''
			if( next !== undefined ) {
				if( field.inverse_field() ) this.table_custom().field_inverse_pair( field, null )
				if( !next ) {
					field.target_dataset( null )
					return ''
				}
				const dataset = this.relation_datasets()
					.find( item => item.dataset.link().str === new $giper_baza_link( next ).str )?.dataset ?? null
				field.target_dataset( dataset )
				return dataset?.link().toString() ?? ''
			}
			return field.target_dataset()?.link().toString() ?? ''
		}

		override relation_display_visible( col: number ) {
			const items = super.relation_display_visible( col )
			if( !this.relation_dataset( col ) ) return items
			return [ ... items, this.Inverse_field_label( col ), ... this.inverse_field( col ) ? [] : [ this.Inverse_field_name( col ), this.Inverse_field_create( col ) ] ]
		}

		inverse_field_options( col: number ) {
			const field = this.table_custom().fields()[ ( this as unknown as $shm_hitalama_map_widget_float_table ).data_col_index( col ) ]
			const target = field?.target_dataset()
			return {
				'': 'Без обратного столбца',
				...Object.fromEntries( ( target?.fields() ?? [] )
					.filter( candidate => candidate.type() === 'list_link' || field?.type() === 'list_link' && candidate.type() === 'atom_link' )
					.filter( candidate => !candidate.inverse_field() || candidate.inverse_field()?.link().str === field?.link().str )
					.filter( candidate => !candidate.target_dataset() || candidate.target_dataset()?.link().str === this.table_custom().link().str )
					.map( candidate => [ candidate.link().toString(), candidate.title() ] ) ),
			}
		}

		inverse_field( col: number, next?: string ) {
			const source = this.table_custom()
			const field = source.fields()[ ( this as unknown as $shm_hitalama_map_widget_float_table ).data_col_index( col ) ]
			if( !field ) return ''
			if( next === undefined ) return field.inverse_field()?.link().toString() ?? ''
			const candidate = next ? field.target_dataset()?.fields().find( item => item.link().str === new $giper_baza_link( next ).str ) ?? null : null
			source.field_inverse_pair( field, candidate )
			return candidate?.link().toString() ?? ''
		}

		inverse_field_create_enabled( col: number ) {
			return !!this.inverse_field_name( col ).trim()
		}

		@ $mol_action
		inverse_field_create( col: number, event?: Event ) {
			if( event === undefined ) return null
			const source = this.table_custom()
			const field = source.fields()[ ( this as unknown as $shm_hitalama_map_widget_float_table ).data_col_index( col ) ]
			if( !field ) return event
			source.field_inverse_create( field, this.inverse_field_name( col ) )
			this.inverse_field_name( col, '' )
			return event
		}

		relation_display_options( col: number ) {
			const field = this.table_custom().fields()[ ( this as unknown as $shm_hitalama_map_widget_float_table ).data_col_index( col ) ]
			const dataset = field?.target_dataset()
			return {
				'': 'Первый подходящий',
				...Object.fromEntries( ( dataset?.fields() ?? [] )
					.filter( target => target.type() !== 'atom_link' && target.type() !== 'list_link' )
					.map( target => [ target.link().toString(), target.title() ] ) ),
			}
		}

		relation_display( col: number, next?: string ) {
			const field = this.table_custom().fields()[ ( this as unknown as $shm_hitalama_map_widget_float_table ).data_col_index( col ) ]
			if( !field ) return ''
			if( next === undefined ) return field.display_field()?.link().toString() ?? ''
			const target = next ? field.target_dataset()?.fields().find( candidate => candidate.link().str === new $giper_baza_link( next ).str ) ?? null : null
			field.display_field( target )
			return target?.link().toString() ?? ''
		}

		override cell_content_text( id: { row: number[], col: number } ) {
			const index = ( this as unknown as $shm_hitalama_map_widget_float_table ).data_col_index( id.col )
			const name = this.widget().table_head()[ index ]
			const record = this.cell_record( id )
			if( !record ) return []
			if( name === 'Дата создания' || name === 'Дата обновления' ) {
				const value = record.system_values()[ name as 'Дата создания' | 'Дата обновления' ]
				return [ value ? new Intl.DateTimeFormat( 'ru-RU', { dateStyle: 'short', timeStyle: 'short' } ).format( Number( value ) ) : '' ]
			}
			const field = this.table_custom().fields()[ index ]
			if( !field ) return []
			const value = record.value( field )
			if( field?.type() === 'json' ) {
				return [ value && typeof value === 'object' ? JSON.stringify( value ) : '' ]
			}
			if( field.type() !== 'atom_link' && field.type() !== 'list_link' ) return [ value ?? '' ]
			const options = this.table_custom().field_link_options( field.title() )
			const links = Array.isArray( value ) ? value : value ? [ value ] : []
			return [ links.map( link => options[ String( link ) ] ?? String( link ) ).join( ', ' ) ]
		}

		@ $mol_mem_key
		override custom_cell_content( id: { row: number[], col: number } ) {
			const field = this.cell_field( id )
			const record = this.cell_record( id )
			if( !field || !record ) return []
			const value = record.value( field )
			const code = this.col_custom_code( id.col ).trim()
			if( !code ) return [ value ?? '' ]

			const row = record.object( this.table_custom().fields() )
			const row_index = Number( id.row[ 1 ] )
			const result = this.$.$mol_error_fence(
				()=> this.map().execute( code, {
					[ '$' + 'table' ]: this.widget().table(),
					[ '$' + 'row' ]: row,
					[ '$' + 'row_index' ]: row_index,
					[ '$' + 'column' ]: field.title(),
					[ '$' + 'value' ]: value,
					[ '$' + 'widget' ]: this.widget(),
					[ '$' + 'view' ]: this,
					[ '$' + 'cell_id' ]: id,
					[ '$' + 'record' ]: record,
					[ '$' + 'dataset' ]: this.table_custom(),
					[ '$' + 'field' ]: field,
				} ),
				error => `Ошибка: ${ error instanceof Error ? error.message : String( error ) }`,
			)
			if( this.$.$mol_promise_like( result ) ) throw result
			return Array.isArray( result ) ? result : [ result ?? '' ]
		}

		@ $mol_mem
		query_date_formatter() {
			return new Intl.DateTimeFormat( 'ru-RU', {
				year: 'numeric', month: '2-digit', day: '2-digit',
				hour: '2-digit', minute: '2-digit',
			} )
		}

		query_value( value: unknown, col: number ) {
			const name = this.widget().table_head()[ col ]
			if( name === 'Дата создания' || name === 'Дата обновления' ) {
				return value ? this.query_date_formatter().format( Number( value ) ) : ''
			}
			const field = this.table_custom().fields()[ col ]
			if( field?.type() === 'json' ) return value && typeof value === 'object' ? JSON.stringify( value ) : ''
			if( !field || ( field.type() !== 'atom_link' && field.type() !== 'list_link' ) ) {
				return $shm_hitalama_map_widget_float_table.prototype.query_value.call( this, value, col )
			}
			const options = this.table_custom().field_link_options( field.title() )
			const links = Array.isArray( value ) ? value : value ? [ value ] : []
			return links.map( link => options[ String( link ) ] ?? String( link ) ).join( ', ' )
		}

		csv_cell( value: unknown ) {
			const text = value === null || value === undefined ? '' : String( value )
			return /[;"\r\n]/.test( text ) ? `"${ text.replaceAll( '"', '""' ) }"` : text
		}

		csv_text() {
			const head = this.widget().table_head().map( String )
			const rows = this.widget().table().table_rows()
			const columns = ( $shm_hitalama_map_widget_float_table.prototype.visible_data_indexes as () => number[] ).call( this )
			const lines = [
				columns.map( ( column: number )=> this.csv_cell( head[ column ] ) ),
				... this.filtered_indexes().map( ( row: number )=> columns.map( ( column: number ) =>
					this.csv_cell( this.query_value( rows[ row ]?.[ column ], column ) ),
				) ),
			]
			return lines.map( row => row.join( ';' ) ).join( '\r\n' )
		}

		csv_blob() {
			return new $mol_blob([ '\uFEFF', this.csv_text() ], { type: 'text/csv;charset=utf-8' })
		}

		csv_file_name() {
			const title = this.widget().title().trim()
				.replace( /[<>:"/\\|?*\u0000-\u001F]+/g, '_' )
				.replace( /[. ]+$/g, '' )
			return `${ title || 'table' }.csv`
		}

		@ $mol_mem
		override Csv_download() {
			const button = super.Csv_download()
			const download = button.click.bind( button )
			button.click = ()=> {
				download()
				this.Map_page().contextmenu_showed( false )
			}
			return button
		}

		@ $mol_mem_key
		edit_data_value( name: string, next?: any ) {
			const dataset = this.table_custom()
			const field = dataset.fields().find( field => field.title() === name )
			const record = this.table_record( this.edit_row_index() )
			if( !field || !record ) return ''

			if( next === undefined ) return record.value( field )
			const value = field.type() === 'date' && next
				? new $mol_time_moment( next ).toString( 'DD.MM.YYYY' )
				: next
			record.value( field, value )
			;( this as unknown as $shm_hitalama_map_widget_float_table ).edit_record( record.object( dataset.fields() ) )
			return next
		}

		@ $mol_action
		record_submit( row_i: number, object: Record< string, any > ) {
			const dataset = this.table_custom()
			let message = ''
			if( row_i < 0 ) {
				const record = dataset.record_add( object )
				if( this.related_source_record() || this.related_source_table() ) this.related_attach( record )
				message = `Создана запись №${ dataset.records().length }`
			} else {
				dataset.record_update( row_i, object )
				;( this as unknown as $shm_hitalama_map_widget_float_table ).edit_row_index( -1 )
				message = `Обновлена строка №${ row_i + 1 }`
			}
			$shm_hitalama_notifications.success( message )
			return message
		}

		@ $mol_action
		override col_name_commit( col: number, next?: Event ) {
			if( !next ) return null
			const table_view = this as unknown as $shm_hitalama_map_widget_float_table
			const index = table_view.data_col_index( col )
			const dataset = this.table_custom()
			const field = dataset.fields()[ index ]
			if( !field ) return next

			const old_name = field.title()
			const new_name = this.col_name_draft( col ).trim()
			if( !new_name || new_name === old_name ) {
				if( next.type !== 'input' ) this.col_name_draft( col, old_name )
				return next
			}
			if( dataset.field_names().includes( new_name ) ) {
				if( next.type !== 'input' ) {
					this.col_name_draft( col, old_name )
					$shm_hitalama_notifications.warning( `Поле «${ new_name }» уже существует` )
				}
				return next
			}

			field.title( new_name )
			const table = this.widget().table()
			const codes = table.col_custom_codes()
			if( Object.prototype.hasOwnProperty.call( codes, old_name ) ) {
				const renamed = { ...codes, [ new_name ]: codes[ old_name ] }
				delete renamed[ old_name ]
				table.col_custom_codes( renamed )
			}
			table.cols_hidden( table.cols_hidden().map( name => name === old_name ? new_name : name ) )
			table.cols_order( table.cols_order().map( name => name === old_name ? new_name : name ) )
			table.cols_pinned( table.cols_pinned().map( name => name === old_name ? new_name : name ) )
			const filter = table_view.filter_by_name( old_name )
			const renamed_filter = table_view.filter_by_name( new_name )
			renamed_filter.mode( filter.mode() )
			renamed_filter.value( filter.value() )
			renamed_filter.until( filter.until() )
			filter.mode( 'all' )
			if( table_view.sort_state().name === old_name ) table_view.sort_state({ ...table_view.sort_state(), name: new_name })
			this.col_name_draft( col, new_name )
			if( next.type !== 'blur' && next.type !== 'input' ) this.Col_settings( col ).showed( false )
			if( next.type !== 'input' ) $shm_hitalama_notifications.success( `Столбец переименован в «${ new_name }»` )
			return next
		}

		@ $mol_action
		override add() {
			if( !this.fullscreen() && ( this.related_source_record() || this.related_source_table() ) ) {
				const widget = this.map().widget_add( 'form2',
					[ this.widget().body_x() + this.widget().right_edge_x(), this.widget().body_y() ], 450, 780,
					undefined, '', new $giper_baza_link( this.table_custom().link().str ) )!
				widget.title( 'Новая связанная запись' )
				widget.Dataset( null )?.val( new $giper_baza_link( this.table_custom().link().str ) )
				if( this.related_source_record() && this.related_source_field() ) {
					widget.Relation_source_record( null )?.val( new $giper_baza_link( this.related_source_record() ) )
					widget.Relation_source_field( null )?.val( new $giper_baza_link( this.related_source_field() ) )
				} else if( this.related_source_table() ) {
					widget.Relation_source_table( null )?.val( new $giper_baza_link( this.related_source_table() ) )
					widget.Relation_source_row( null )?.val( this.related_source_row() )
					widget.Relation_source_name( null )?.val( this.related_source_name() )
				}
				return
			}
			if( this.fullscreen() ) return super.add()

			const dataset = this.table_custom()
			let form = this.map().Widgets_list()?.remote_list().find( widget =>
				widget.type() === 'form2' && widget.Dataset()?.remote()?.link().str === dataset.link().str
					&& !widget.Record2()?.remote()
					&& !widget.Relation_source_record()?.remote() && !widget.Relation_source_table()?.remote()
			)
			if( !form ) {
				form = this.map().widget_add(
					'form2',
					[ this.widget().body_x() + this.widget().right_edge_x(), this.widget().body_y() ],
					450,
					780,
					'Новая строка',
					'',
					new $giper_baza_link( dataset.link().str ),
				)
			}
			if( !form ) return
			this.Map_page().go_to_widget( form.link() )
		}

		@ $mol_action
		override cell_delete( id: { row: number[], col: number } ) {
			const row_i = Number( id.row[ 1 ] )
			if( !this.table_custom().record_delete( row_i ) ) return

			const table = this.widget().table()
			const checks = table.Rows_checked()?.val() as Record< number, boolean > ?? {}
			const shifted: Record< number, boolean > = {}
			for( const key in checks ) {
				let index = Number( key )
				if( index === row_i ) continue
				if( index > row_i ) --index
				shifted[ index ] = checks[ key ]
			}
			table.Rows_checked( null )?.val( shifted )
		}

		@ $mol_action
		cell_edit_custom_open( row_i: number ) {
			const widget = $mol_wire_sync( this ).cell_edit_custom_widget( row_i )
			if( !widget ) return
			this.Map_page().go_to_widget( widget.link() )
			this.Map_page().contextmenu_showed( false )
		}

		@ $mol_action
		cell_edit_custom_widget( row_i: number ) {
			const dataset = this.table_custom()
			const record = this.table_record( row_i )
			if( !record ) return null!
			let widget = this.map().Widgets_list()?.remote_list().find( widget =>
				widget.type() === 'form2'
					&& widget.Dataset()?.remote()?.link().str === dataset.link().str
					&& widget.Record2()?.remote()?.link().str === record.link().str
			)
			if( !widget ) {
				widget = $mol_wire_sync( this.map() ).widget_add(
					'form2',
					$mol_wire_sync( Array ).of( this.widget().body_x() + this.widget().right_edge_x(), this.widget().body_y() ) as number[],
					450,
					780,
					undefined,
					'',
					new ( $mol_wire_sync( $giper_baza_link ) )( dataset.link().str ),
				)
			}
			if( !widget ) return null!
			widget.title( `Строка ${ row_i + 1 }` )
			widget.Dataset( null )?.val( new $giper_baza_link( dataset.link().str ) )
			// A freshly constructed absolute link must be serialized in the form widget land.
			// Reusing the record link may reuse its land-relative binary cache.
			widget.Record2( null )?.val( new $giper_baza_link( record.link().str ) )
			return widget
		}

	}

}
